import * as actions from "../../actions";
import {trim} from 'lodash';
import {getApiConfig, getMasterFabricatorId} from "../../utilities";
import {NEW_SCOPE_SET_WIZARD_MODE} from "../../constants/actionTypes";

let abortablePromise = null;

const ActionTypes = {
  loadFeaturesGroupsStart: 'project-scope-new/load-features-groups-start',
  loadFeaturesGroupsEnd: 'project-scope-new/load-features-groups-end',
  resetAll: 'project-scope-new/reset-all',
  setSearchTerm: 'project-scope-new/set-search-term',
  setMode: 'project-scope-new/set-mode',
  updateFeatureGroup: 'project-scope-new/update-feature-group',
  cancelPendingChanges: 'project-scope-new/cancel-pending-changes',
  mergePendingChanges: 'project-scope-new/merge-pending-changes',
  unloadFeaturesGroups: 'project-scope-new/unload-features-groups',
  updateFeatureGroups: 'project-scope-new/update-feature-groups',
}

export default {
  loadFeaturesGroups(singleRequest = true) {
    return (dispatch, getState) => {
      if(abortablePromise) {
        abortablePromise.abort();
        abortablePromise = null;
      }
      dispatch({
        type: ActionTypes.loadFeaturesGroupsStart
      })
      if (singleRequest) {
        dispatch(actions.loadingDialog_show(true, 'Loading...', 'Loading features groups, this will take just a moment.'))
      }

      const state = getState();
      const {auth, asCustomer, projectScopeNew:{term, mode}, newScope} = state;
      const fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;

      let query = '';
      // if (term) {
      //   query += "searchFilter="+ term;
      // }
      if (mode !== 'All') {
        // query += (term ? "&" : "") + "productType=" + (mode === 'Kitchen' ? 'KitchenVisualizer' : 'BathroomVisualizer');
        query += "productType=" + (mode === 'Kitchen' ? 'KitchenVisualizer' : 'BathroomVisualizer');
      }
      if (query) {
        query = '?' + query;
      }
      const featuresGroupsRequestCount = state.projectScopeNew.featuresGroupsRequestCount;
      var tool = newScope.categoriesVisualizer;
      let masterFabId = getMasterFabricatorId(asCustomer.data ? asCustomer.data.masterFabricatorIds: auth.masterFabricatorIds, tool);
      abortablePromise = getApiConfig('ProjectScope');
      return abortablePromise.get(`/features-groups/${fabricatorId}/${masterFabId}${query}`)
        .then(data => {
          // console.log("featuresGroupsRequestCount", featuresGroupsRequestCount);
          // console.log("state.projectScopeNew.featuresGroupsRequestCount", state.projectScopeNew.featuresGroupsRequestCount);
          if (featuresGroupsRequestCount === state.projectScopeNew.featuresGroupsRequestCount) { // set only the latest request
            if (singleRequest) {
              dispatch(actions.loadingDialog_show(false))
            }
            dispatch({
              type: ActionTypes.loadFeaturesGroupsEnd,
              payload: data
            })
            return true
          }
          return false
        })
        .catch((error) => {
          if (error.code === 20 && (error.message === 'The user aborted a request.'
            || error.message === 'signal is aborted without reason')) {
            return false // do not remove the loader as it is still loading (receiving new groups)
          }
          if (featuresGroupsRequestCount === state.projectScopeNew.featuresGroupsRequestCount) {
            dispatch({
              type: ActionTypes.loadFeaturesGroupsEnd,
              payload: {groups: []}
            })
          }
          if (singleRequest) {
            dispatch(actions.loadingDialog_show(false))
          }
          console.error("feature-group-features error", error);
          return false
        });
    }
  },

  unloadFeaturesGroups() {
    return (dispatch) => {
      dispatch({
        type: this.ActionTypes.unloadFeaturesGroups
      });
    }
  },

  setSearchTerm(term) {
    return (dispatch, getState) => {
      const {featuresGroupsAll} = getState().projectScopeNew;
      let newFeaturesGroups = [...featuresGroupsAll];
      if (term) {
        const lowerCasedSearchText = term.trim().toLowerCase();
        newFeaturesGroups = newFeaturesGroups.filter(featureGroup => {
          if (!featureGroup) {
            return false
          }
          if (featureGroup.customDisplayName
            && featureGroup.customDisplayName.trim().toLowerCase().includes(lowerCasedSearchText)) {
            return true
          }
          return featureGroup.groupName && featureGroup.groupName.trim().toLowerCase().includes(lowerCasedSearchText);
        })
      }
      dispatch({
        type: this.ActionTypes.setSearchTerm,
        payload: {term, featuresGroups: newFeaturesGroups}
      })
    }
  },

  setMode(mode) {
    return {
      type: this.ActionTypes.setMode,
      payload: {mode}
    }
  },

  updateFeatureGroup(featureGroup) {
    return {
      type: this.ActionTypes.updateFeatureGroup,
      payload: {featureGroup}
    }
  },

  updateFeatureGroups(featuresGroups) {
    return {
      type: this.ActionTypes.updateFeatureGroups,
      payload: {featuresGroups}
    }
  },

  cancelPendingChanges() {
    return {
      type: this.ActionTypes.cancelPendingChanges
    }
  },

  setWizardMode(isWizardMode) {
    return {
      type: NEW_SCOPE_SET_WIZARD_MODE,
      payload: {isWizardMode}
    }
  },

  savePendingChanges() {
    return (dispatch, getState) => {
      const {pendingChanges, term} = getState().projectScopeNew;

      dispatch(actions.loadingDialog_show(true, 'Saving...', 'Saving features groups, this will take just a moment.'))
      getApiConfig('ProjectScope').post(pendingChanges, `/feature-groups-save`)
      .then(response => {
        dispatch(actions.loadingDialog_show(false));
        if(response.success) {
          dispatch({
            type: this.ActionTypes.mergePendingChanges
          });
          dispatch(this.loadFeaturesGroups());
        } else {
          dispatch(actions.messageBox_Show(true, 'error', 'An error occurred', response.error));
        }
      });
    }
  },

  ActionTypes
}

